import { render, staticRenderFns } from "./circadianLights.vue?vue&type=template&id=70c75c48&"
import script from "./circadianLights.vue?vue&type=script&lang=js&"
export * from "./circadianLights.vue?vue&type=script&lang=js&"
import style0 from "./circadianLights.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports